import { ActivityStudentModel } from '@/models/data-lake/data-lake';
import { dataLakeAPI } from '@/providers/apis/data-lake/data-lake';
import { Vue, Component, Prop } from 'vue-property-decorator';

@Component({
    name: 'student-access-activities-table',
})

export default class StudentAccessActivitiesTable extends Vue {

    // ----------------------------------------------------------
    // Properties

    @Prop()
    private dateRange: any;

    private totalStudent: number = 0;

    private tableFields: any = [
        {
            label: 'Activity',
            key: 'activityName',
            thClass: 'activity-head',
            tdClass: 'activity-body',
        },
        {
            label: 'Vendor',
            key: 'toolName',
            thClass: 'activity-head',
            tdClass: 'activity-body',
        },
        {
            label: '# of Students',
            key: 'studentCount',
        },
        {
            label: 'Total Timespent',
            key: 'timespent',
        },
    ];

    private activitiesData: ActivityStudentModel[] = [];

    private vendorList: any = [];

    private currentPage: number = 1;

    private perPage: number = 10;

    private offset: number = 0;

    private isLoading: boolean = false;

    private searchTerms: string = '';

    // -------------------------------------------------------------
    // Hooks

    private created() {
        this.onLoadData();
    }

    // -------------------------------------------------------------
    // Actions

    private onGoBack() {
        this.$router.push('/data-lake-report');
    }

    private onChangePage(page: number) {
        this.currentPage = page;
        if (page * this.perPage > this.activitiesData.length) {
            this.offset = (page - 1) * this.perPage;
            this.onLoadData();
        }
    }

    private onSearch() {
        this.activitiesData = [];
        this.onLoadData();
    }

    // -------------------------------------------------------------
    // Methods

    private onLoadData() {
        const dateRange = this.dateRange;
        this.isLoading = true;
        const params = {
            // startDate: dateRange.startDate,
            // endDate: dateRange.endDate,
            // toolname: 'benchmark',
            offset: this.offset,
            limit: this.perPage,
            query: this.searchTerms,
        };
        dataLakeAPI.fetchStudentsByActivity(params).then((activityData: any) => {
            this.totalStudent = activityData.reduce((a: any, b: any) => a + b.studentCount, 0);
            this.activitiesData = [...this.activitiesData, ...activityData];
            this.isLoading = false;
        });
    }
}
